<template>
  <div :class="['group-dropdown-item', active ? 'active' : '']">
    <div
      class="group-title"
      :style="{ 'padding-left': 15 * (level + 1) + 'px' }"
      @click="$emit('group-click', group)"
    >
      <span>{{ group.label || group.title }}</span>
      <i class="el-icon-arrow-down"></i>
    </div>
    <div class="group-item-wrapper" :style="containerStyle">
      <div
        v-for="option in group.options"
        :class="['group-item', isSelected(option.value) ? 'selected' : '']"
        :key="option.value"
        :style="{ 'padding-left': 15 * (level + 2) + 'px' }"
        @click="$emit('select', { option, group })"
        v-tip
      >
        {{ getLabel(option) }}
        <div class="right">
          <des-popper
            v-if="explain"
            :value="option.explain"
            style="position: absolute; right: 24px;"
          ></des-popper>
          <i class="el-icon-check"></i>
        </div>
      </div>
      <group-dropdown-item
        ref="subGroup"
        v-for="(childGroup, idx) in group.children || []"
        :key="idx"
        :group="childGroup"
        :active="curGroup === idx"
        :selected="selected"
        :explain="explain"
        :level="level + 1"
        @group-click="toggleGroupState(idx)"
        @select="$emit('select', $event)"
        class="sub-dropdown-item"
        is-sub-group
        @height-change="refreshItemWrapperHeight"
      ></group-dropdown-item>
    </div>
  </div>
</template>

<script>
import DesPopper from "@/components/BaseComponents/DesPopper"
export default {
  name: "group-dropdown-item",
  components: { DesPopper },
  props: {
    group: {
      type: Object,
      default: () => ({
        label: "分组名",
        options: [{ label: "选项名", value: "选项值" }],
        children: [] // 子group
      })
    },
    active: Boolean,
    isSubGroup: Boolean,
    selected: Array,
    explain: {
      type: Boolean,
      default: false
    },
    level: {
      type: Number,
      default: 0
    }
  },
  watch: {
    active() {
      this.refreshItemWrapperHeight()
    },
    group() {
      this.$nextTick(() => {
        this.refreshItemWrapperHeight()
      })
    }
  },
  computed: {
    containerStyle() {
      return {
        height: this.itemWrapperHeight + "px"
      }
    }
  },
  data() {
    return {
      curGroup: -1,
      itemWrapperHeight: 0
    }
  },
  methods: {
    toggleGroupState(groupIndex) {
      if (groupIndex === this.curGroup) {
        this.curGroup = -1
      } else {
        this.curGroup = groupIndex
      }
    },
    refreshItemWrapperHeight() {
      if (!this.active) {
        this.itemWrapperHeight = 0
      } else {
        let optionsHeight = (this.group.options || []).length * 36
        let childHeight = [].concat(this.$refs.subGroup || []).reduce(
          (sum, subGroup) => sum + 36 + (subGroup.active ? subGroup.itemWrapperHeight : 0), // 36是分组标题(group-title)高度
          0
        )
        this.itemWrapperHeight = optionsHeight + childHeight
      }
      this.$emit("height-change", this.itemWrapperHeight)
    },
    isSelected(value) {
      return this.selected?.includes(value)
    },
    getLabel(option) {
      if (option.customLabel) {
        return option.customLabel
      }
      let label = option.label || ""
      return this._.trim(label.slice(label.lastIndexOf("]") + 1))
    }
  }
}
</script>

<style lang="scss" scoped>
.group-dropdown-item {
  &.active > {
    .group-title {
      color: #1e88e5;
      .el-icon-arrow-down {
        transform: rotate(-180deg);
      }
    }
  }
  &.sub-dropdown-item {
    .group-title {
      padding-left: 0;
    }
  }
  .group-title {
    display: flex;
    padding: 0 16px;
    align-items: center;
    height: 36px;
    cursor: pointer;
    &:hover {
      color: #1e88e5;
    }
    span {
      flex: 1;
    }
    .el-icon-arrow-down {
      transition: transform 0.3s ease;
    }
  }
  .group-item-wrapper {
    overflow: hidden;
    transition: height 0.3s ease;
    .group-item {
      height: 36px;
      line-height: 36px;
      padding-right: 15px;
      cursor: pointer;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      background-color: #f5f7fa;
      .right {
        margin-left: auto;
        position: relative;
        display: flex;
        align-items: center;
        .el-icon-check {
          display: none;
        }
      }
      &:hover {
        background-color: #e8ebf1;
      }
      &.selected {
        color: #1e88e5;
        .el-icon-check {
          display: unset;
        }
      }
    }
  }
}
</style>
